export default "__VITE_ASSET__DjuaOw36__"